import { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { toast } from 'react-toastify';
import {errorMsg, getModelSimpleSearch} from '../../../../../Apis/functions';
import HandleChange from '../../../../../Helpers/HandleChange';
import {
    CreateExtraMeal,
    GetFoodieApprovalByRequestMealId,
    UpdateExtraOrders
} from '../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi';
import {FOODIE_EXTRA_MEAL, hasValidNumberOfMeals} from '../Model/Models';
import SessionData from "../../../../../Helpers/SessionData";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {getAllMealtimes} from "../../../../../reduxToolkit/FoodieOrders/FoodieOrdersApi";
import {TABLES} from "../../../../../Apis/Tables";
import {
    SERVICE_ADVANCED_SEARCH,
    SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER
} from "../../../../../reduxToolkit/Commons/CommonsApi";

/**
 * @Author: Arnulfo ferro
 * @JobTitle : Frontend
 * @Email : azapata@ibl.mx
 *
 */
const CreateUpdateRequest = (onHide, t, itemSelected, setModified, extraMealType) => {
    const dispatch = useDispatch();
    const { mealtimes } = useSelector((state) => state.FoodieOrdersSlice);
    const [emptyFields, setEmptyFields] = useState(false);
    const [isMealNumberValid, setIsMealNumberValid] = useState(true);
    const [item, setItem] = useState({ ...FOODIE_EXTRA_MEAL });
    const [cleanChipSearch, setCleanChipSearch] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [disabledNumberMeals, setDisabledNumberMeals] = useState(false);
    const { getUserSession } = SessionData();
    const { id: requestingId } = getUserSession();
    const isUpdate = Boolean(itemSelected?.id);
    const [foodieApproval, setFoodieApproval] = useState({id: null, reason: ""})
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const [apiSearchEmployee, setApiSearchEmployee] = useState(null);

    useEffect(() => {
        if(itemSelected?.id && parseInt(itemSelected?.approvalStatusId) === STATUS_MODEL.CHANGES_REQUESTED)
            dispatch(GetFoodieApprovalByRequestMealId(itemSelected?.id)).then(({payload:{data:{success, data}}})=> {
                if(success) {
                    setFoodieApproval({...data});
                }
            });
    }, [itemSelected]);

    // extending handleChaange
    const { handleChange: baseHandleChange } = HandleChange({ model: item, setModel: setItem });

    useEffect(() => {
        dispatch(getAllMealtimes());
    }, [dispatch]);

    // wrapper to extend handleChange functionality
    const handleChange = (evt, name) => {
        baseHandleChange(evt, name);

        const fieldName = name || evt?.target?.name;

        switch (fieldName) {
            case "mealsNumber":
                if (evt?.target?.value) {
                    setSelectedList([]);
                    setItem(prev => ({ ...prev, usersId: [], departmentIds: []}));
                    setIsMealNumberValid(hasValidNumberOfMeals(evt?.target?.value));
                }
                break;
        }
    };

    useEffect(() => {
        if (Array.isArray(selectedList)) {
            const usersId = selectedList.map(item => item.id);

            setItem(prev => ({
                ...prev,
                usersId : usersId
            }));
        }
    }, [selectedList]);
    /**
     * Effect: When an item is selected for update, set it as the current model.
     * If no item is selected, reset to default with userId.
     */
    useEffect(() => {
        if (isUpdate) {
            const updatedItem = {
                ...FOODIE_EXTRA_MEAL.set(itemSelected),
                requestingId: requestingId ?? null,
                usersId: [itemSelected.userId]
            };

            setItem(updatedItem);
        } else {
            clearFields();
        }
    }, [isUpdate]);

    /**
     * Reset form fields to default values with userId.
     */
    const clearFields = () => {
        setItem({
            ...FOODIE_EXTRA_MEAL,
            requestingId: requestingId ?? null,
            usersId: [],
            departmentIds: [],
            mealsNumber: ''
        });
        setEmptyFields(false);
        setSelectedList([]);
        setDisabledNumberMeals(false);
        setCleanChipSearch(true);
    };

    const handleAddUpdate = () => {
        setEmptyFields(false);

        if (!item.isValid(extraMealType, selectedList)) {
            setEmptyFields(true);
            return;
        }

        const config = isUpdate
            ? { body: item.toUpdate(), action: UpdateExtraOrders, toastMsg: 'has_been_updated_successfully' }
            : { body: item.toRegister(extraMealType, selectedList), action: CreateExtraMeal, toastMsg: 'has_been_created_successfully' };

        dispatch(config.action(config.body)).then(({ payload }) => {
            const { success, code } = payload?.data || {};
            if (success) {
                toast.success(t(config.toastMsg));
                setModified(true);
                handleHide();
            } else {
                errorMsg(code);
            }
        });
    };

    const handleHide = () => {
        clearFields();
        onHide();
        setIsMealNumberValid(true)
        setEmptyFields(false)
    };

    const getBodyApi = () => {
        if(contractorId){
            setApiSearchEmployee(SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER);
            return getModelSimpleSearch( TABLES.USER_BY_CONTRACTOR_ID,
                {
                    userId: contractorId,
                    userTypeIds: [STATUS_MODEL.ACTIVE] //userTypeIds used for statusIds
                });
        }

        if(supplierId){
            setApiSearchEmployee(SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER);
            return getModelSimpleSearch( TABLES.USER_BY_SUPPLIER_ID,
                {
                    userId: supplierId,
                    userTypeIds: [STATUS_MODEL.ACTIVE] //userTypeIds used for statusIds
                });
        }

        setApiSearchEmployee(SERVICE_ADVANCED_SEARCH);
        return  getModelSimpleSearch( TABLES.USER_BY_USER_TYPE,
            {
                userTypeIds: [USER_TYPE_MODEL.EMPLOYEE] //userTypeIds used for userTypeIds
            })
    }

    return {
        item,
        handleChange,
        handleAddUpdate,
        emptyFields,
        isMealNumberValid,
        handleHide,
        cleanChipSearch,
        setCleanChipSearch,
        selectedList,
        setSelectedList,
        disabledNumberMeals,
        isUpdate,
        foodieApproval,
        clearFields,
        mealtimes,
        getBodyApi,
        apiSearchEmployee
    };
};

export default CreateUpdateRequest;
